// Handle the quantity increment/decrement and
// disabled state of buttons/

$(".counter-js.counter__decrement").on("click", function () {
  if ($(".counter-js.counter__value").val() > 0) {
    $(".counter-js.counter__value").val(function (_, prevValue) {
      prevValue == 1 &&
        $(".counter-js.counter__decrement").attr("disabled", true);
      return --prevValue;
    });
  }
});

$(".counter-js.counter__increment").on("click", function () {
  $(".counter-js.counter__value").val(function (_, prevValue) {
    prevValue == 0 &&
      $(".counter-js.counter__decrement").removeAttr("disabled");
    return ++prevValue;
  });
});
